import { TextField } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { calculateHeight, calculateWidth, rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  textFieldInput: {
    height: calculateHeight(50).stringValue,
    width: calculateWidth(160).stringValue,
    fontSize: rem(1.125),
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: '2px 2px 0',
    outline: 'hidden',
  },
  priceUnit: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  HeadlineCaption: {
    fontSize: rem(0.875),
    color: theme.palette.info.main,
    letterSpacing: rem(0.016),
    textAlign: 'center',
  },
  subHeading: {
    fontSize: rem(1.125),
    display: 'inline-block',
    color: themeColor.bigstones,
    letterSpacing: rem(0.032),
    lineHeight: calculateHeight(20).stringValue,
    '&.-last': {
      marginTop: '60px',
    },
  },
  greyUnderline: {
    borderBottom: `1px solid ${themeColor.borderGray}`,
  },
  halfOpacity: {
    color: themeColor.subheaderLight,
  },
  priceInput: {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    height: calculateHeight(70).stringValue,
  },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CssTextField = withStyles(_theme => ({
  root: {
    '& label': {
      fontSize: vh(2.34),
    },
    '& label.Mui-focused': {
      color: themeColor.defaultTextColor,
    },
    '&>.MuiOutlinedInput-root': {
      fontSize: vh(2.73),
      paddingRight: '0px',
      '& fieldset': {
        border: 'none',
      },
      '& input': {
        textAlign: 'center',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& p.MuiFormHelperText-root': {
      color: themeColor.defaultTextColor,
    },
  },
}))(TextField);
